import { AxiosInstance } from "axios";
import { ICore } from "./interfaces";

export function approveUserAddressBuilder(apiClient: AxiosInstance) {
  return async function approveUserAddress(
    shipmentId: number,
    payload: ICore.ConfirmShippingAddressRequest,
  ): Promise<any> {
    const response = await apiClient.post(
      `/packages/shipments/physical-books/${shipmentId}/confirm-address/`,
      payload,
    );
    return response.data;
  };
}
